// extracted by mini-css-extract-plugin
export default {"switch":"pill-switch_switch__FKwZn","switchSecondActive":"pill-switch_switchSecondActive__igJYU","button":"pill-switch_button__Iqme1"};